import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingOverrides } from '@zag/core/common';
import { FormattingService } from './formatting.service';

/**
 * Formats a time value using the active locale-aware formatting context.
 *
 * Usage:
 * ```html
 * {{ myDate | zagTime }}
 * {{ myDate | zagTime : { timeZone: 'UTC' } }}
 * ```
 */
@Pipe({
  name: 'zagTime',
  pure: false,
})
export class ZagTimePipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  transform(value: Date | string | number | null | undefined, overrides?: FormattingOverrides): string {
    if (value == null) {
      return '';
    }
    return this.formattingService.formatTime(value, overrides);
  }
}
